import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useEventListener } from '@redneckz/uni-jsx/lib/hooks/useEventListener';
import { defaultEventBus } from '../../EventBus/defaultEventBus.js';
import { assertUnreachable } from '../../utils/assertUnreachable.js';
import { style } from '../../utils/style.js';
export const PopupManager = JSX(() => {
    const [popup, setPopup] = useState(null);
    const close = useCallback(() => {
        setPopup(null);
    }, []);
    useEffect(() => defaultEventBus.subscribe('popup', (action) => {
        switch (action.type) {
            case 'open':
            case 'update':
                setPopup(action);
                break;
            case 'close':
                close();
                break;
            default:
                assertUnreachable(action);
        }
    }), []);
    const escapeHandler = useCallback(({ key }) => {
        if (key === 'Escape') {
            close();
        }
    }, [close]);
    useEventListener(globalThis.document, 'keydown', escapeHandler);
    return popup ? (_jsx("div", { className: style('z-50', popup.fixed ? 'fixed' : 'absolute'), style: {
            left: `${popup.left}px`,
            top: `${popup.top}px`,
            ...(popup.width ? { width: `${popup.width}px` } : {}),
        }, role: "dialog", children: popup.popup })) : null;
});
//# sourceMappingURL=PopupManager.js.map